
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tim-buu-cuc",
      function () {
        return require("private-next-pages/tim-buu-cuc/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tim-buu-cuc"])
      });
    }
  